import { render, staticRenderFns } from "./KisAdmin.vue?vue&type=template&id=dd50eec4"
import script from "./KisAdmin.js?vue&type=script&lang=js&external"
export * from "./KisAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports